import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { colorUtils, layout, media } from 'src/components/base';
import { PaginationItem } from './pagination-items';

const { measurements, animations } = layout;

export const Pagination = styled.ul`
  display: flex;
  justify-content: center;
  list-style: none;
  margin: 0;
`;

type PaginationItemProps = {
  indicateOmittedPages: PaginationItem['indicateOmittedPages'];
  omitOnSmallDevices: PaginationItem['omitOnSmallDevices'];
};

export const PaginationListItem = styled.li<PaginationItemProps>(
  ({ indicateOmittedPages, omitOnSmallDevices }) => css`
    margin-left: ${indicateOmittedPages === 'before'
      ? measurements.spacing150
      : 0};
    margin-right: ${indicateOmittedPages === 'after'
      ? measurements.spacing150
      : measurements.spacing025};

    ${media.smallOnly`
      margin-left: ${
        indicateOmittedPages === 'before' ? measurements.spacing050 : 0
      };
      margin-right: ${
        indicateOmittedPages === 'after'
          ? measurements.spacing050
          : measurements.spacing025
      };
    `}

    @media screen and (max-width: 420px) {
      ${omitOnSmallDevices ? 'display: none;' : ''}

      @media screen and (max-width: 350px) {
        margin: 0 ${measurements.spacing025} 0 0;
      }
    }

    &:last-child {
      margin-right: 0;
    }
  `
);

const paginationLinkStyles = css`
  align-items: center;
  border-radius: 8px;
  display: flex;
  font-weight: 600;
  height: 30px;
  justify-content: center;
  min-width: 30px;
  padding: ${measurements.spacing050};
  transition: all ${animations.buttonTransition};

  ${media.smallOnly`
      padding: ${measurements.spacing025};
    `};
`;

export const PaginationLink = styled(Link)`
  ${paginationLinkStyles}
  background: ${props => props.theme.bg.primary};
  box-shadow: ${props => `inset 0 0 0 1px ${props.theme.lines.primary}`};
  color: ${props => props.theme.text.primary};

  &:hover,
  &.focus-visible {
    background: ${props =>
      colorUtils.setRgbaAlpha(props.theme.buttons.primary.bg, '0.2')};
    box-shadow: none;
  }
`;

export const DisabledPaginationLink = styled.span`
  ${paginationLinkStyles}
  box-shadow: ${props => `inset 0 0 0 1px ${props.theme.lines.primary}`};
  color: ${props => props.theme.text.quaternary};
  background: ${props => props.theme.bg.secondary};
  cursor: default;
`;

export const CurrentPaginationLink = styled.span`
  ${paginationLinkStyles}
  background: ${props => props.theme.buttons.primary.bg};
  color: ${props => props.theme.buttons.primary.text};
  cursor: default;
`;
